import { render, staticRenderFns } from "./PrivacyZonesCanvas.vue?vue&type=template&id=806af10c&"
import script from "./PrivacyZonesCanvas.vue?vue&type=script&lang=js&"
export * from "./PrivacyZonesCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('806af10c')) {
      api.createRecord('806af10c', component.options)
    } else {
      api.reload('806af10c', component.options)
    }
    module.hot.accept("./PrivacyZonesCanvas.vue?vue&type=template&id=806af10c&", function () {
      api.rerender('806af10c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/Settings/PrivacyZones/PrivacyZonesCanvas.vue"
export default component.exports